import React from 'react';
import {Link} from 'react-router-dom'

function SelectedProductItem(props) {

    const moreInfoButtonStyle={
        background: 'red',
        color: '#fff',
        padding: '2%',
        borderRadius: '20px',
        position: 'absolute',
        bottom: '8px',
    }
    return (
        <div className={props.cols ? props.cols : 'col-md-6 col-lg-4'}>
            <div className="blog-item">
                
                <figure className="blog-thumb" style={{display:"flex", justifyContent:"center"}}>
                    {/* <Link to={`${process.env.PUBLIC_URL + blogURL}`}> */}
                        <img src={props.img} alt={props.title} style={{maxHeight:'270px'}}/>
                    {/* </Link> */}
                </figure>
                   

                <div className="blog-content">
                    <Link to={`/product/${props.alias}/${props.productId}`} style={{color:"#000"}}>
                        <h2 className="h5">{props.title}</h2>
                        <p dangerouslySetInnerHTML={{__html: props.excerpt}}/>
                        <div className="blog-meta">
                        <Link to={'/product'+ `/${props.alias}/${props.productId}`} style={moreInfoButtonStyle}>اطلاعات بیشتر...</Link>
                        </div>
                    </Link>
                </div>

            </div>
        </div>
    );
}

export default SelectedProductItem;
